import React from 'react';
import Panel from './Panel';
import PessoaJuridica from '../../components/Panel/ResumeNew/PessoaJuridica';
//import Resume from '../../components/Panel/ResumeNew/';




const PessoaJuridicaPage = () => {

    return (
        <Panel>
            <div>
                <PessoaJuridica />
            </div>
        </Panel>

    );
};

export default PessoaJuridicaPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/PessoaJuridicaPage.js
 **/